// ESM is fine with Parcel:
import IcalExpander from "ical-expander";
import { kendoCalendarMonthNum } from "./config";

// if you keep require(), that’s okay too:
// const IcalExpander = require("ical-expander");

const fetchIcalData = async (url) => {
  const res = await fetch(url);
  const text = await res.text();
  return text;
};

export const icalWorkerAddress =
  "https://orange-pond-c97e.joonas-joensuu.workers.dev/";

export const parseIcal = async function (url) {
  const ics = await fetchIcalData(url);

  // optional guard in case your proxy ever serves HTML fallback:
  if (!/^BEGIN:VCALENDAR/m.test(ics)) {
    throw new Error("Expected ICS, got something else");
  }

  const icalExpander = new IcalExpander({
    ics, // <-- key change
    maxIterations: 100, // optional
    skipInvalidDates: true,
  });

  const today = new Date();
  const upperLimitDate = new Date();
  upperLimitDate.setMonth(today.getMonth() + kendoCalendarMonthNum);

  const events = icalExpander.between(today, upperLimitDate);

  const mappedEvents = events.events.map((e) => ({
    startDate: e.startDate,
    endDate: e.endDate,
    summary: e.summary,
    location: e.location,
    organizer: e.organizer,
    description: e.description,
    categories: e.component.getFirstPropertyValue("categories"),
  }));

  const mappedOccurrences = events.occurrences.map((o) => ({
    startDate: o.startDate,
    endDate: o.endDate,
    summary: o.item.summary,
    location: o.item.location,
    organizer: o.item.organizer,
    description: o.item.description,
    // categories: o.item.component.getFirstPropertyValue("categories"),
  }));
  const allEvents = [].concat(mappedEvents, mappedOccurrences);
  const result = allEvents.map((e) => {
    const jsStartDate = e.startDate.toJSDate();
    const jsEndDate = e.endDate.toJSDate();
    const startDate = new Intl.DateTimeFormat("fi-FI").format(jsStartDate);
    const endDate = new Intl.DateTimeFormat("fi-FI").format(jsEndDate);

    return {
      jsStartDate: jsStartDate,
      jsEndDate: jsEndDate,
      startDate: startDate,

      endDate: endDate,
      oneDay: startDate === endDate ? true : false,
      summary: e.summary,
      location: e.location,
      organizer: e.organizer,
      description: e.description,
      categories: e.categories,
      startWeekDay: {
        fi: getWeekDay(jsStartDate, "fi"),
        se: getWeekDay(jsStartDate, "se"),
        en: getWeekDay(jsStartDate, "en"),
      },
      endWeekDay: {
        fi: getWeekDay(jsEndDate, "fi"),
        se: getWeekDay(jsEndDate, "se"),
        en: getWeekDay(jsEndDate, "en"),
      },
    };
  });
  //     e.startDate.toJSDate().toISOString()} - ${e.summary}`)
  //   .join("\n");

  return result;
};

export const filterEventsByTerm = function (events, terms) {
  return events
    .filter((e) => {
      const summary = e.summary.toLowerCase();
      let result = false;
      terms.forEach((term) => {
        term = term.toLowerCase();
        if (summary.includes(term)) result = true;
      });
      return result;
    })
    .sort((a, b) => a.jsStartDate - b.jsStartDate);
};

export const getWeekDay = function (date, lang = "se") {
  const formatName = {
    fi: "fi-FI",
    se: "sv-FI",
    en: "en-FI",
  };
  const jsDay = date.getDay();
  return new Intl.DateTimeFormat(formatName[lang], { weekday: "short" }).format(
    date
  );
};
